const unwrapCoord = (value) => {
  if (value == null || value === "") return NaN;
  if (typeof value === "function") {
    try {
      return unwrapCoord(value());
    } catch {
      return NaN;
    }
  }
  if (typeof value === "object") {
    if (typeof value.toNumber === "function") return Number(value.toNumber());
    if (typeof value.valueOf === "function") {
      const primitive = value.valueOf();
      if (primitive !== value) return unwrapCoord(primitive);
    }
  }
  return Number(value);
};

export const toLatLngLiteral = (point) => {
  if (point == null || typeof point !== "object") return null;

  const rawLat =
    point.lat ??
    point.latitude ??
    point.Latitude ??
    point.location?.lat ??
    point.location?.latitude;
  const rawLng =
    point.lng ??
    point.longitude ??
    point.Longitude ??
    point.location?.lng ??
    point.location?.longitude;

  const lat = unwrapCoord(rawLat);
  const lng = unwrapCoord(rawLng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};

export const calculateDistance = (p1, p2) => {
  if (!p1 || !p2) return null;

  // Normalise inputs: support {lat,lng} or {latitude,longitude}
  const lat1 = p1.lat !== undefined ? parseFloat(p1.lat) : parseFloat(p1.latitude);
  const lng1 = p1.lng !== undefined ? parseFloat(p1.lng) : parseFloat(p1.longitude);
  const lat2 = p2.lat !== undefined ? parseFloat(p2.lat) : parseFloat(p2.latitude);
  const lng2 = p2.lng !== undefined ? parseFloat(p2.lng) : parseFloat(p2.longitude);


  if (
    isNaN(lat1) || isNaN(lng1) ||
    isNaN(lat2) || isNaN(lng2)
  ) {
    console.warn("Invalid coordinates:", { p1, p2 });
    return null;
  }

  const R = 6371e3; // Earth radius in meters
  const φ1 = lat1 * Math.PI / 180;
  const φ2 = lat2 * Math.PI / 180;
  const Δφ = (lat2 - lat1) * Math.PI / 180;
  const Δλ = (lng2 - lng1) * Math.PI / 180;

  const a = Math.sin(Δφ/2) ** 2 +
            Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ/2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(Math.min(1, a)), Math.sqrt(1 - Math.min(1, a)));

  return R * c; // ✅ return meters
};


export function toRad(deg) {
  return (deg * Math.PI) / 180;
}
export function toDeg(rad) {
  return (rad * 180) / Math.PI;
}

export function calculateBearing(start, end) {
  const φ1 = toRad(start.latitude);
  const φ2 = toRad(end.latitude);
  const Δλ = toRad(end.longitude - start.longitude);

  const y = Math.sin(Δλ) * Math.cos(φ2);
  const x =
    Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);

  return (toDeg(Math.atan2(y, x)) + 360) % 360; // bearing [0,360)
}
